import React from 'react';
import { Col, Row } from "antd";

import { useColumnsChildren } from "components/use-hooks";


const ShowroomCompanyWrap = ({children, className = null}) => {

    const { leftColumn, rightColumn } = useColumnsChildren(children);

    const spanList = {
        left: { xs: 0, sm: 0, lg: 6, xl: 8, xxl: 8, span: 8 },
        right: { xs: 24, sm: 24, lg: 18, xl: 16, xxl: 16, span: 16 }
    };

    return (
        <Row className={className} type="flex" gutter={ 24 } justify="center">
            <Col { ...spanList.left }>
                { leftColumn }
            </Col>
            <Col { ...spanList.right }>
                { rightColumn }
            </Col>
        </Row>
    );
};

export default ShowroomCompanyWrap;